<template>
    <van-popup
            v-if="selectProductTransferPopupShow" v-model="selectProductTransferPopupShow" z-index="100" :close-on-click-overlay="false" @click-overlay="handleClickClose"
            :style="{ height: '100vh',width: '100vw', background: '#fff' }" overlay-class="custom_popup" position="right">

        <div class="product_out_wrap" v-loading="loading">
            <div class="product_out_top">
                <div class="returnNavBar">
                    <div class="returnNavBarLeft">
                        <van-icon @click="handleClickClose" name="arrow-left" />
                        <span class="normal_title">返回</span>
                    </div>
                </div>
                <div class="search_wrap">
                    <van-search v-model="keyword"  placeholder="请输入产品名称"  @clear="handleClickSearch" @search="handleClickSearch"></van-search>
                </div>
            </div>
            <div class="product_out_bottom">
                <div class="product_out_bottom_right">
                    <ul v-infinite-scroll="onLoadList">
                        <li v-for="item in  tableData">
                            <div class="title_text">
                                <div v-text="item.name"></div>
                                <p >
                                    {{item.stocks.name}} {{item.total_num}} {{item.unit}}
                                </p>
                            </div>
                            <div class="btns">
                                <span @click="handleClickConfirm(item)">选择</span>
                            </div>
                        </li>
                    </ul>
                </div>




            </div>
        </div>
    </van-popup>

</template>

<script>
import { stockProductList,stockList} from "@/api/index.js"
import {pagination} from '@/mixins'
export default {
    name: "select_product_transfer",
    components: {},
    props: {
        selectProductTransferPopupShow: {
            type: Boolean,
            default: false,
        },
        stockId:{
            type:Number,
            default:0
        },
        selectData:{
            type:Array,
            default:()=>[]
        },
    },
    data() {
        return {
            keyword:'',
            BtnDisabled:false,
            tableData:[],

        };
    },
    mixins: [pagination],
    created() {
        this.getTableData()
    },
    methods: {
        handleClickSearch(){
            this.tableData = []
            this.pagination.pageNum = 1
            this.getTableData()
        },
        onLoadList(){
            if(this.pagination.total == this.tableData.length){
                return false
            }
            if(this.loading == false){
                this.getTableData();
            }
        },
        getTableData(){
            this.loading = true
            let postData = {
                page: this.pagination.pageNum,
                pageSize: this.pagination.pageSize,
                keyword:this.keyword,
                id: this.stockId,
            }
            stockProductList(postData).then(res => {
                if (res.code === 200) {
                    let {list, total} = res.data
                    this.pagination.total = total
                    this.tableData =  this.tableData.concat(list)
                    this.pagination.pageNum++;
                }
                this.loading = false
            })
        },
        handleClickConfirm(item) {
            if(this.selectData.find(find => find.name == item.name)){
                this.$toast('该产品已选择')
                return false
            }

            this.$emit("success", item)
            this.$emit("update:selectProductTransferPopupShow", false)

        },
        handleClickClose(){
            this.$emit("update:selectProductTransferPopupShow", false)
        },

    },
}
</script>

<style  lang="scss" scoped>
.custom_popup {
    background-color: rgba(0, 0, 0, 0.3);
}
.product_out_wrap{
    width: 100%;
    height: 100vh;
    display: flex;
    flex-direction: column;
    .product_out_top{
        width: 100%;
    }
    .product_out_bottom{
        width: 100%;
        .product_out_bottom_right{
            width: 100%;
            height: 100%;
            overflow: auto;
            background: #fff;
            ul{
                width: 100%;
                padding: 0 16px 0px 12px;
                box-sizing: border-box;
                li{
                    width: 100%;
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    padding: 12px 0 10px;
                    border-bottom: 1px solid rgba(232, 232, 232, 1);
                    box-sizing: border-box;
                    .title_text{
                        width: calc(100% - 48px);
                        div{
                            line-height: 22px;
                            color: rgba(51, 51, 51, 1);
                            font-size: 14px;
                            margin-bottom: 4px;
                            font-weight: bold;
                        }
                        p{
                            line-height: 18px;
                            font-size: 12px;
                            color: rgba(102, 102, 102, 1);
                        }
                    }
                    .btns{
                        width: 40px;
                        span{
                            width: 40px;
                            height: 24px;
                            border-radius: 4px;
                            background: rgba(255, 255, 255, 1);
                            border: 1px solid rgba(41, 144, 255, 1);
                            font-size: 12px;
                            color: rgba(41, 144, 255, 1);
                            text-align: center;
                            line-height: 22px;
                            box-sizing: border-box;
                            display: block;
                        }
                    }
                }
            }
        }
    }
}

</style>